import axios from 'axios';
import getCurrentLang from '@/scripts/helpers/getCurrentLang';

// axios calls base url
axios.defaults.baseURL = `/api/${getCurrentLang()}`;

window.axios = axios;